import React from "react";
import { Card } from "react-bootstrap";
import Bar from '../Bar';

const Final = ({ values }) => {

    //destructuring the object from values
  const { fullName, companyName, fixedcostsvalue, variablecostsvalue, profitmarginratio, restaurantsValue, email, phoneNumber } = values;

  return (
    <>
    <Bar/>
      <Card style={{ marginTop: 100, textAlign: "left" }}>
        <Card.Body>
          
          <p>
            <strong>Full Name :</strong> {fullName}{" "}
          </p>
          <p>
            <strong>Company Name :</strong> {companyName}{" "}
          </p>
          <p>
            <strong>Fixed Costs Value :</strong> {fixedcostsvalue}{" "}
          </p>
          <p>
            <strong>Variable Costs Value :</strong> {variablecostsvalue}{" "}
          </p>
          <p>
            <strong>Profit Margin Ratio :</strong> {profitmarginratio}{" "}
          </p>
          <p>
            <strong>Restaurants :</strong> {restaurantsValue}{" "}
          </p>
          <p>
            <strong>Email :</strong> {email}{" "}
          </p>
          <p>
            <strong>Phone :</strong> {phoneNumber}{" "}
          </p>
        </Card.Body>
      </Card>
    </>
  );
};

export default Final;